"use client"
// needed for context menu

import { Button, Text } from "@/elements"
import Image from "next/image"
import Link from "next/link"
import { MediaItem } from "../../../../components/MediaItem"
import { useState } from "react"

interface SpotlightEntry {
  creator_name: string
  creator_handle: string
  creator_location: string
  creator_profile_picture: {
    id: string
    filename_disk: string
    title: string
    type: string
    width: number
    height: number
  }
  spotlight_files: {
    directus_files_id: { id: string; filename_disk: string; title: string; type: string; width: number; height: number }
  }[]
  spotlight_text_content: string
}
type SpotlightEntries = {
  entries: SpotlightEntry[]
}

export const SpotlightEntries: React.FC<SpotlightEntries> = ({ entries }) => {
  return (
    <div className="flex flex-col gap-y-[88px]">
      {entries.map(
        (
          {
            creator_handle,
            creator_location,
            creator_name,
            creator_profile_picture,
            spotlight_files,
            spotlight_text_content,
          },
          index
        ) => {
          return (
            <div key={index} className="flex flex-col gap-y-6">
              {spotlight_files.map((file, index) => {
                return <MediaItem playInView={true} key={index} file={file.directus_files_id} />
              })}

              <div className="flex flex-row items-center gap-x-4">
                {creator_profile_picture?.filename_disk ? (
                  <img
                    src={`${process.env.NEXT_PUBLIC_DIRECTUS_CLOUDFRONT_DOMAIN}/public/${creator_profile_picture.filename_disk}`}
                    alt={creator_profile_picture.title}
                    width={creator_profile_picture.width}
                    height={creator_profile_picture.height}
                    className="size-[64px] rounded-full"
                  />
                ) : null}
                <div className="flex flex-col gap-y-1">
                  <Text variant="h6">{creator_name}</Text>
                  <Text className="text-fg-2">{creator_location}</Text>
                </div>
                <Link href={`/${creator_handle}`} target="_blank" className="ml-auto">
                  <Button variant="tertiary" className="!bg-transparent">
                    View profile
                  </Button>
                </Link>
              </div>
              <Text className="text-fg-2">{spotlight_text_content}</Text>
            </div>
          )
        }
      )}
    </div>
  )
}
